import { render, staticRenderFns } from "./Repair.vue?vue&type=template&id=36d7fa7a&scoped=true&"
import script from "./Repair.vue?vue&type=script&lang=js&"
export * from "./Repair.vue?vue&type=script&lang=js&"
import style0 from "./Repair.vue?vue&type=style&index=0&id=36d7fa7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7fa7a",
  null
  
)

export default component.exports